/**
 * CheckoutLayout — Main checkout + Address Manager screen switching
 *
 * SCREEN_MAIN        → Cart + Address summary card + Payment
 * SCREEN_ADDRESS     → Full address list/add/edit with back button
 */

import React, { useState } from "react";
import { LogoutOutlined } from "@ant-design/icons";
import { Button, Divider, Row, Col, Space } from "antd";
import { useAuth } from "../../context/AuthContext";
import CartSummary from "./CartSummary";
import SelectAddress from "./SelectAddress";
import AddressManager from "./AddressManager.jsx";
import PaymentOptions from "./PaymentOptions";

const SCREEN = {
  MAIN:    "main",
  ADDRESS: "address",
};

const CheckoutLayout = ({
  fetchCart,
  cartData,
  setPaymentStatus,
  setAppLoader,
  setHeaderTitle,
}) => {
  const { logout, getUser } = useAuth();
  const [screen, setScreen]   = useState(SCREEN.MAIN);
  const [address, setAddress] = useState(null);

  const user  = getUser();
  const phone = user?.mobile || user?.username || "";

  // ─── ADDRESS MANAGER SCREEN ─────────────────────────────────────────────────
  if (screen === SCREEN.ADDRESS) {
    return (
      <AddressManager
        selectedAddress={address}
        onSelectAddress={(addr) => setAddress(addr)}
        onBack={() => {
          setScreen(SCREEN.MAIN);
          setHeaderTitle?.(null);
        }}
        setHeaderTitle={setHeaderTitle}
      />
    );
  }

  // ─── MAIN CHECKOUT SCREEN ───────────────────────────────────────────────────
  return (
    <div style={{ padding: "16px 0 40px" }}>

      {/* 1. Order Summary */}
      <SectionLabel>Order summary</SectionLabel>
      <CartSummary cartData={cartData} />

      <div style={{ height: 20 }} />

      {/* 2. Delivery Address — summary card only */}
      <SectionLabel>Delivery</SectionLabel>
      <SelectAddress
        address={address}
        setAddress={setAddress}
        setAppLoader={setAppLoader}
        onManageAddress={() => setScreen(SCREEN.ADDRESS)}
      />

      <div style={{ height: 20 }} />

      {/* 3. Payment — only when address is selected */}
      {address && (
        <>
          <SectionLabel>Payment Method</SectionLabel>
          <PaymentOptions
            fetchCart={fetchCart}
            cartData={cartData}
            address={address}
            setPaymentStatus={setPaymentStatus}
            setAppLoader={setAppLoader}
          />
          <div style={{ height: 20 }} />
        </>
      )}

      {/* 4. Footer */}
      <Divider style={{ margin: "4px 0 12px" }} />
      <Row justify="space-between" align="middle">
        <Col>
          <span style={{ fontSize: 12, color: "#aaa" }}>
            Logged in with{" "}
            <span style={{ fontWeight: 600, color: "#555" }}>+91 {phone}</span>
          </span>
        </Col>
        <Col>
          <Button
            size="small"
            icon={<LogoutOutlined />}
            onClick={logout}
            style={{ fontSize: 12, borderRadius: 6, color: "#666", borderColor: "#ddd" }}
          >
            Log Out
          </Button>
        </Col>
      </Row>

    </div>
  );
};

const SectionLabel = ({ children }) => (
  <div style={{
    fontSize: 12,
    fontWeight: 600,
    color: "#999",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 8,
  }}>
    {children}
  </div>
);

export default CheckoutLayout;